import React from 'react';
import '../../../style/Dashboard.css';
// import DashNav from './DashNav';
import DashBoardScreen from './DashBoardScreen';
export default function Dashhboard() {
  return (
   <>
  


 <DashBoardScreen/>
   
   </>
  )
}
